import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

import axios from "axios";

const useStyles = makeStyles((theme) => ({
  button: {
    display: "block",
    marginTop: theme.spacing(2),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
}));

export default function FormDialog(props) {
  const classes = useStyles();

  const [open, setOpen] = React.useState(false);

  const [openRol, setOpenRol] = React.useState(false);
  const [openEmpresa, setOpenEmpresa] = React.useState(false);

  const [empresa, setEmpresa] = React.useState("");
  const [rol, setRol] = React.useState("");
  const [name, setName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  //---
  const handleCloseSelectRol = () => {
    setOpenRol(false);
  };

  const handleOpenSelectRol = () => {
    setOpenRol(true);
  };

  const handleChangeSelectRol = (e) => {
    setRol(e.target.value);
    setOpenRol(false);
  };

  //---
  const handleCloseSelectEmpresa = () => {
    setOpenEmpresa(false);
  };

  const handleOpenSelectEmpresa = () => {
    setOpenEmpresa(true);
  };

  const handleChangeSelectEmpresa = (e) => {
    setEmpresa(e.target.value);
    setOpenEmpresa(false);
  };

  const handleSave = async () => {
    if (
      name.trim().length > 0 &&
      rol.trim().length > 0 &&
      email.trim().length > 5 &&
      password.trim().length > 5 &&
      (empresa.trim().length > 0 || props.user.rol !== "superadmin")
    ) {
      axios("https://us-central1-cattlebirths.cloudfunctions.net/widgets", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        data: {
          name: name,
          empresa:
            props.user.rol !== "superadmin" ? props.user.empresa : empresa,
          password: password,
          email: email,
          rol: rol,
        },
      });

      setName("");
      setEmail("");
      setPassword("");
      setEmpresa("");
      setRol("");
      setOpen(false);
    }
  };

  return (
    <div>
      <div onClick={handleClickOpen}>{props.children}</div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Crear cuenta</DialogTitle>
        <DialogContent>
          <DialogContentText>Ingresa los datos de la cuenta</DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="nombre"
            label="Nombre"
            type="text"
            fullWidth
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <br />
          <TextField
            autoFocus
            margin="dense"
            id="Email"
            label="Email"
            type="email"
            fullWidth
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <br />
          <TextField
            autoFocus
            margin="dense"
            id="password"
            label="Contraseña"
            type="text"
            fullWidth
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <FormControl className={classes.formControl}>
            <InputLabel id="demo-controlled-open-select-label">Rol</InputLabel>
            <Select
              labelId="demo-controlled-open-select-label"
              id="demo-controlled-open-select"
              open={openRol}
              onClose={handleCloseSelectRol}
              onOpen={handleOpenSelectRol}
              value={rol}
              onChange={handleChangeSelectRol}
            >
              <MenuItem value=""></MenuItem>
              <MenuItem value={"operario"}>Operario</MenuItem>
              <MenuItem value={"admin"}>Admin</MenuItem>
            </Select>
          </FormControl>
          <br />

          {props.user && props.user.rol === "superadmin" && (
            <FormControl className={classes.formControl}>
              <InputLabel id="demo-controlled-open-select-label">
                Establecimiento
              </InputLabel>
              <Select
                labelId="demo-controlled-open-select-label"
                id="demo-controlled-open-select"
                open={openEmpresa}
                onClose={handleCloseSelectEmpresa}
                onOpen={handleOpenSelectEmpresa}
                value={empresa}
                onChange={handleChangeSelectEmpresa}
              >
                {props.empresas.map((emp) => (
                  <MenuItem key={emp.id} value={emp.id}>
                    {emp.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleSave} color="primary">
            Guardar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
